export default __webpack_public_path__ + "media/images/dashboard_icons/envelope-54341b0d0ec641125c10c82ca0ce171d.svg";